export default "__VITE_ASSET__CdazJ8iZ__"